export interface FormatPercentageOptions {
  percentage: number;
  showSign?: boolean;
  maximumFractionDigits?: number;
  roundingMode?:
    | 'ceil'
    | 'floor'
    | 'expand'
    | 'trunc'
    | 'halfCeil'
    | 'halfFloor'
    | 'halfExpand'
    | 'halfTrunc'
    | 'halfEven';
  locale?: string;
}

const LOCALE_CUSTOM_FORMATS: Record<string, (amount: string) => string> = {
  'pt-PT': (amount: string) => {
    return amount.replace(/%/g, ' %');
  },
};

function normalizePercent(amount: string, locale: string) {
  const transform = LOCALE_CUSTOM_FORMATS[locale];
  return transform ? transform(amount) : amount;
}

export function formatPercentage({
  percentage,
  showSign = false,
  maximumFractionDigits = 2,
  roundingMode = 'halfEven',
  locale = 'en-US',
}: FormatPercentageOptions) {
  return normalizePercent(
    new Intl.NumberFormat(locale, {
      style: 'percent',
      roundingMode,
      maximumFractionDigits,
      signDisplay: showSign ? 'exceptZero' : 'auto',
    }).format(percentage / 100),
    locale
  );
}
